export * from '@uifabric/icons';



// WEBPACK FOOTER //
// ../src/Icons.ts